import { Grid } from "@mui/material";
import { useSegments } from "api/segments";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import _ from "lodash";
import { useState } from "react";
import { useStyles } from "./styles";

export function SegmentDropdown({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();
  const { values, setFieldValue } = useFormikContext<any>();
  const value = _.get(values, fieldName);
  const [segmentSearch, setSegmentSearch] = useState("");
  const { useInfiniteSegmentsList } = useSegments();

  const {
    data: infiniteSegmentsList,
    size: segmentsSize,
    setSize: setSegmentsSize,
    isValidating,
  } = useInfiniteSegmentsList({
    filters: segmentSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: segmentSearch,
          },
        ]
      : [],
    order: "asc",
    sortKey: "name",
  });

  const { infiniteData: segmentsList, anyElementsToFetch: anySegmentsToFetch } =
    useManageInfiniteScroll(infiniteSegmentsList || []);

  const { useSegmentData } = useSegments();
  const { data: selectedSegment } = useSegmentData<string>(value.data);

  return (
    <>
      <Grid item xs={6}>
        <SelectInput
          className={classes.input}
          data-test-id="condition-operator"
          items={[
            {
              id: "not_contains",
              label: message({ id: "doesNotContain" }),
            },
            {
              id: "contains",
              label: message({ id: "contains" }),
            },
          ]}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={() => {
            setFieldValue(`${fieldName}.data`, []);
          }}
        />
      </Grid>
      {["not_contains", "contains"].indexOf(value.operator) >= 0 && (
        <Grid item xs={12}>
          <SelectInput
            displaySearch
            data-test-id="condition-value"
            items={
              segmentsList
                ? segmentsList.map(({ name, segmentId }) => ({
                    id: segmentId,
                    label: name,
                  }))
                : []
            }
            label={<RequiredFieldLabel text={message({ id: "condition" })} />}
            name={`${fieldName}.data`}
            asyncSearch={(searchedQuery) => setSegmentSearch(searchedQuery)}
            initialValue={
              selectedSegment && {
                id: selectedSegment.segmentId,
                label: selectedSegment.name,
              }
            }
            anyElementsToFetch={anySegmentsToFetch}
            loadMoreElements={() =>
              !isValidating && setSegmentsSize(segmentsSize + 1)
            }
          />
        </Grid>
      )}
    </>
  );
}
